import { http } from '@/api/http';

export default  {

    /**
     *  comment 评论服务接口
     */

    // course 课件评论 {course_id}
    getCourseComment(course,chapter,section) {
        return http.get(`/api/comment/course/${course}_${chapter}_${section}`);
    },

    getMoreCourseComment(course,chapter,section,count,currentComment) {
        return http.get(`/api/comment/course/${course}_${chapter}_${section}?Limit=${count}&currentComment=${currentComment}`);
    },
    // 评论模块的swagger需要url需去掉v1加上/comment，如下示例
    getCourseSonComment(Limit,comment_id,currentComment) {
        return http.get(`/api/comment/comment/${comment_id}/replyList?Limit=${Limit}&currentComment=${currentComment}`);
    },

    addCourseComment(course,chapter,section,data) {
        return http.post(`/api/comment/course/${course}_${chapter}_${section}`,data);
    },
    giveTheThumbUp(comment_id,data) {
        return http.put(`/api/comment/comment/${comment_id}/like`,data);
    },
    cancelTheThumbUp(comment_id,data) {
        return http.delete(`/api/comment/comment/${comment_id}/like`,data, {contentType:'json'});
    },
    deleteComent(comment_id,data) {
        return http.delete(`/api/comment/comment/${comment_id}`,data, {contentType:'json'});
    },

    /**
     * 评分
     */
    getTrainScore(id) {
        return http.get(`/api/comment/score/${id}`);
    },
    /**
     * 培训资源管理
     */
    reserveRoomQuery(data) {
        return http.get(`/api/reserveRoom/ReserveQuery`, data);
    },
    //获取培训教室
    getRoomQuery(data) {
        return http.get(`/api/trainingRoom/RoomQuery`,data);
    },
    //服务项
    getEquipmentQuery(data) {
        return http.get(`/api/trainingRoom/EquipmentQuery`,data);
    },
    //预定记录详情
    getReserveRoomRecordDetail(id){
        return http.get(`/api/reserveRoom/GetRecordDetail/${id}`);
    },
    //审批
    reserveRoomApprove(id,data) {
        return http.put(`/api/reserveRoom/Approve/${id}`,data, {contentType:'form'});
    },
    //添加培训室
    trainingRoomUpSert(data) {
        return http.post(`/api/trainingRoom/RoomUpSert`,data, {contentType:'form'});
    },
    //单个删除培训室
    trainingRoomDelete(id) {
        return http.put(`/api/trainingRoom/DeleteRoom/${id}`);
    },
    //批量删除培训室
    trainingRoomDeleteRoomBatch(data) {
        return http.put(`/api/trainingRoom/DeleteRoomBatch`,data, {contentType:'form'});
    },
    //添加服务项
    trainingRoomEquipmentUpsert(data) {
        return http.post(`/api/trainingRoom/EquipmentUpsert`,data, {contentType:'form'});
    },
    //单个删除服务项
    trainingRoomDeleteEquipment(id) {
        return http.put(`/api/trainingRoom/DeleteEquipment/${id}`);
    },
    //批量删除服务项
    trainingRoomDeleteBatchEquipment(data) {
        return http.put(`/api/trainingRoom/DeleteBatchEquipment`,data, {contentType:'form'});
    },
    //获取某个培训教室详情
    getRoomInfoQuery(id) {
        return http.get(`/api/trainingRoom/RoomInfo/${id}`);
    },
    //获取某个服务项详情
    getEquipmentInfoQuery(id) {
        return http.get(`/api/trainingRoom/EquipmentInfo/${id}`);
    },
    /**
     * 考勤打卡
     */
    //获取组织列表
    getPlanOperationAuth() {
        return http.get(`/clockApi/plan/operationAuth`);
    },
    //获取排班列表
    getTimeSheetPlan(data) {
        return http.get(`/clockApi/plan`,data);
    },
    //添加排班
    addTimeSheetPlan(data) {
        return http.post(`/clockApi/plan`,data);
    },
    //更新排班
    editTimeSheetPlan(id,data) {
        return http.put(`/clockApi/plan/${id}`,data);
    },
    //发布排班
    releaseTimeSheetPlan(id) {
        return http.put(`/clockApi/plan/${id}/release`);
    },
    //审核排班
    auditTimeSheetPlan(id) {
        return http.put(`/clockApi/plan/${id}/audit`);
    },
    //获取排班详情
    getTimeSheetPlanDetail(id) {
        return http.get(`/clockApi/plan/${id}`);
    },
    //删除排班
    deleteTimeSheetPlan(data) {
        return http.delete(`/clockApi/plan`,data, {contentType:'json'});
    },
    //获取考勤统计
    getTimeSheetStatistic(data) {
        return http.get(`/clockApi/statistic`,data);
    },
    //获取考勤统计详情
    getTimeSheetStatisticDetail(id,data) {
        return http.get(`/clockApi/statistic/${id}`,data);
    },
    //获取某排班中每个值班人员的打卡情况
    getTimeSheetClockDetail(id) {
        return http.get(`/clockApi/plan/${id}/clockDetail`);
    },
};
